/**
 * @typedef {Object} Invitation
 * @property {number} id
 * @property {string} createdAt
 * @property {number} expiresAt
 * @property {boolean|null} isAccepted
 * @property {string|null} isExpired
 * @property {string} lang
 * @property {string} token
 * @property {number} contestUserId
 * @property {string} recipientEmail
 * @property {string} recipientFirstname
 * @property {string} recipientLastname
 * @property {string} zip
 * @property {Object} sender
 * @property {number} sender.id
 * @property {string} sender.firstname
 * @property {string} sender.lastname
 * @property {Object} sender.destination
 * @property {number} sender.destination.id
 * @property {string} sender.destination.descriptionEn
 * @property {string} sender.destination.descriptionFr
 * @property {string} sender.destination.titleEn
 * @property {string} sender.destination.titleFr
 * @property {string} sender.destination.imgUrl
 * @property {string} sender.destination.article
 * @property {boolean|null} isSubscribedToContestMessages
 */

import ApiService from "../ApiService"

class InvitationService extends ApiService {
  /**
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super(`${process.env.VUE_APP_CONTEST_API}api/v1/invitations`, parameters)
  }

  getUserInvitations(token) {
    return this.removeParameters()
      .submit("get", `${this.endpoint}?t=${token}`)
      .then(res => {
        return res.data
      })
  }

  /**
   * Get invitation resource for invited user
   * @param id
   * @param token
   * @return {Promise<Invitation>}
   */
  getInvitation(id, token) {
    return this.removeParameters()
      .submit("get", `${this.endpoint}/${id}?t=${token}`)
      .then(res => {
        return res.data
      })
  }

  sendInvitation({ recipientFirstname, recipientEmail }, token) {
    return this.removeParameters()
      .submit("post", `${this.endpoint}?t=${token}`, {
        recipientFirstname,
        recipientEmail
      })
      .then(res => {
        return res.data
      })
  }

  acceptInvitation({
    invitationId,
    recipientFirstname,
    recipientLastname,
    recipientEmail,
    isSubscribedToAirTransatMessages,
    isSubscribedToIdcMessages,
    zip,
    token
  }) {
    return this.removeParameters()
      .submit("put", `${this.endpoint}/${invitationId}?t=${token}`, {
        recipientFirstname,
        recipientLastname,
        recipientEmail,
        isSubscribedToAirTransatMessages,
        isSubscribedToIdcMessages,
        zip,
        isAccepted: true
      })
      .then(res => {
        return res.data
      })
  }
}

export default InvitationService
